import { ArrowLeft } from "lucide-react";

export default function MobileBackNav({ onBack }) {
  return (
    <nav className="mobile-back-nav sm:hidden fixed inset-x-0 bottom-0 z-40 bg-cinema-header/95 backdrop-blur border-t border-cinema-border">
      <div className="max-w-7xl mx-auto px-4 py-2">
        <button
          type="button"
          onClick={onBack}
          className="w-full flex items-center justify-center gap-2 rounded-xl py-2.5 text-sm font-medium bg-steel-700 text-white"
          aria-label="Volver"
        >
          <ArrowLeft size={18} />
          Volver
        </button>
      </div>
    </nav>
  );
}
